import { getIsMsHighContrast } from 'owa-high-contrast';
import { getIsLightBaseTheme, getIsDarkBaseTheme } from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';

/**
 * initialize the svgs icons
 */
let ERROR_STATE;

function initializeDisplayIcons() {
    if (getIsMsHighContrast()) {
        ERROR_STATE = require('owa-empty-state/lib/svg/HighContrast/illustration_error.svg');
    } else if (getIsLightBaseTheme()) {
        ERROR_STATE = require('owa-empty-state/lib/svg/Light/illustration_error.svg');
    } else if (getIsDarkBaseTheme()) {
        ERROR_STATE = require('owa-empty-state/lib/svg/Dark/illustration_error.svg');
    } else if (getIsDarkTheme()) {
        ERROR_STATE = require('owa-empty-state/lib/svg/DarkTheme/illustration_error.svg');
    } else {
        ERROR_STATE = require('owa-empty-state/lib/svg/LightTheme/illustration_error.svg');
    }
}

export function getErrorStateImage() {
    initializeDisplayIcons();

    return ERROR_STATE;
}
